import React, {Component} from 'react';
import { connect } from 'react-redux';
import { firestoreConnect } from 'react-redux-firebase';
import { compose } from 'redux';
import { Redirect, Link } from 'react-router-dom';
import moment from 'moment';
import DeleteModal from './DeleteModal';

class PostDetails extends Component {
    state ={
        show: false
    };

    showModal = () => {
        this.setState({ 
            show: true 
        });
    }

    hideModal = () => {
        this.setState({
            show: false
        });
    }

    render() {
        const { post, auth, postId} = this.props;


        if(!auth.uid) return <Redirect to='/signin'/> 

        if (post) {
            return (
                <div className="container section post-details">
                    <div className="row">
                        <div className="col s12">
                            <div className="card post">
                                <div className="card-content">
                                    <span className="card-title">{ post.title} </span>
                                    <p>{post.content}</p>
                                </div>
                                <div className="card-action">
                                    <p>Posted by {post.authorFirstName} {post.authorLastName}</p>
                                    <p>{post.dateCreated ? moment(post.dateCreated.toDate()).calendar() : null }</p>
                                    {auth.uid === post.authorId &&
                                        <p>Activated: {post.activated ? "Yes": "No"}</p>
                                    }
                                </div>
                                {auth.uid === post.authorId && 
                                    <div className="card-action card-buttons">
                                        <Link to={{pathname: '/edit/' + postId, state: {post: post }}} key={postId} className="waves-effect waves-light btn blue">
                                            Edit
                                        </Link>
                                        <button type="button" className="waves-effect waves-light btn red modal-trigger" onClick={this.showModal}>Delete</button>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>

                    <DeleteModal postid={postId} show={this.state.show} handleClose={this.hideModal} history={this.props.history}></DeleteModal>
                </div>
            )
        }
        else {
            return (
                <div className="container center">
                    <p>Loading post...</p>
                </div>
            )
        }
    }

}

const mapStateToProps = (state, ownProps) => {
    const id = ownProps.match.params.id;
    const posts = state.firestore.data.posts;
    const post = posts ? posts[id] : null;
    return {
        post: post,
        auth: state.firebase.auth,
        postId: id
    }
}

export default compose(
    connect(mapStateToProps, null),
    firestoreConnect([
        { collection: 'posts' }
    ])
)(PostDetails);